import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IContactModel } from '@apps-common/types/management/contact'

export const MANAGEMENT_QUERY_KEY_GET_CONTACT = (contactId?: string) => ['getContact', contactId].filter(Boolean)

export const getContact = async (contactId: string): Promise<IContactModel> =>
  axios.get(`/management/contact/getcontact?contactId=${contactId}`).then((res) => res.data?.data)

type QueryFnType = typeof getContact

type Props = {
  config?: QueryConfig<QueryFnType>
  contactId: string
}

export const useManagementGetContact = ({ config, contactId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: MANAGEMENT_QUERY_KEY_GET_CONTACT(contactId),
    queryFn: () => getContact(contactId)
  })
